<template>
  <div>
    <div class="space-between align-center">
      <div class="align-center flex-1">
        <div class="filter-icon">
          <img src="/img/filter.svg" alt="" />
        </div>

        <div class="search-wrappper">
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Search here...">
            </b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <button
        type="button"
        class="btn mulai btn-secondary font-bold"
        @click="handleNew"
      >
        <fa-icon icon="edit" class="my-icon" />&nbsp; ADD NEW FAQ
      </button>
    </div>
    <br />
    <br />
    <!-- Main table element -->
    <b-table
      show-empty
      stacked="md"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell(publish)="row">
        <b-badge variant="success" v-if="row.item.publish">Publish</b-badge>
        <b-badge variant="secondary" v-else>Unpublish</b-badge>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-3 mb-2 action-button"
          variant="outline-secondary"
          @click="handleEdit(row.item)"
        >
          <fa-icon icon="pencil-alt" class="my-icon" />&nbsp;Edit
        </b-button>
        <b-button
          size="sm"
          class="mr-3 mb-2 action-button"
          variant="outline-warning"
          @click="handlePublish(row.item)" 
          v-if="row.item.publish"
        >
          <fa-icon icon="minus-circle" class="my-icon" />&nbsp;Unpublish
        </b-button>
        <b-button
          size="sm"
          class="mr-3 mb-2 action-button"
          variant="outline-success"
          @click="handlePublish(row.item)" 
          v-else
        >
          <fa-icon icon="plus-circle" class="my-icon" />&nbsp;Publish
        </b-button>
        <b-button
          size="sm"
          class="mr-3 mb-2 action-button"
          variant="outline-danger"
          @click="handleDelete(row.item)"
        >
          <fa-icon icon="minus-circle" class="my-icon" />&nbsp;Delete
        </b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal
      v-model="addModal"
      id="addModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="addModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">{{editData ? "Edit FAQ" : "Create New FAQ"}}</h3>
        <br />
        <label>Question</label>
        <br />
        <b-form-textarea
          v-model="inputData.question"
          placeholder="Enter something..."
          rows="3"
        ></b-form-textarea>
        <br />
        <label>Answer</label>
        <quill-editor
          class="editor"
          v-model="inputData.answer"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @ready="onEditorReady($event)"
        >
        </quill-editor>
        <br />
        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="handleSave"
          >
            SAVE
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'font': [] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'video']
          ]
        }
      },
      editData: false,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "id",
          label: "#ID", 
          sortable: true,
          sortDirection: "asc"
        },
        {
          key: "question",
          label: "Question",
          sortable: true
        },
        {
          key: "publish",
          label: "Status",
          sortable: true
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      addModal: false,
      inputData: {
        id: 0,
        question: "",
        answer: "", 
        publish: false
      },
      showLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },

  mounted() {
    this.totalRows = this.items.length;
    this.faqList();
  },

  methods: {
    ...mapActions({
      getFaqList: types.GET_FAQ_LIST,
      createFaq: types.CREATE_FAQ,
      updateFaq: types.UPDATE_FAQ, 
      publishFaq: types.PUBLISH_FAQ, 
      deleteFaq: types.DELETE_FAQ
    }),
    onEditorBlur(quill) {
      // console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      // console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      // console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.inputData.answer = html;
    },
    faqList() {
      this.isBusy = true;
      this.getFaqList()
        .then(response => {
          this.items = response;
          this.totalRows = response.length;
          this.isBusy = false;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleNew() {
      this.addModal = true;
      this.editData=false;
      this.inputData = {
        id: 0,
        question: "",
        answer: "", 
        publish: false
      }
    },
    handleEdit(item) {
      this.addModal = true;
      this.editData = true;
      this.inputData = {
        id: item.id,
        question: item.question,
        answer: item.answer, 
        publish: item.publish ? true : false
      }
    },
    handleSave() {
      if(this.editData) {
        this.editFaq();
      } else {
        this.addFaq();
      }
    },
    handleDelete(item) {
      this.$bvModal.msgBoxConfirm('Delete this data?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            this.deleteFaq({id:item.id})
              .then(response => {
                this.faqList();
                this.showMessageBox("Deleted", "Success", "success");
              })
              .catch(error => {
                this.showMessageBox(error, "Failed", "success");
              });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "success");
        });
    },
    handlePublish(item) {
      var flag = item.publish ? 0 : 1
      var text = item.publish ? 'Unpublish' : 'Publish'

      this.$bvModal.msgBoxConfirm( text + ' this data?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            this.publishFaq({id:item.id, publish: flag})
              .then(response => {
                this.faqList();
                this.showMessageBox(text+"ed", "Success", "success");
              })
              .catch(error => {
                this.showMessageBox(error, "Failed", "success");
              });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "success");
        });
    },
    addFaq() {
      this.showLoading = true;

      var payload = {
        question: this.inputData.question, 
        answer: this.inputData.answer, 
        publish: this.inputData.publish ? 1 : 0
      }

      this.createFaq(payload)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.addModal = false;
          this.showLoading = false;
          this.faqList();
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
    },
    editFaq() {
      this.showLoading = true;

      var payload = {
        id: this.inputData.id,
        question: this.inputData.question, 
        answer: this.inputData.answer, 
        publish: this.inputData.publish ? 1 : 0
      }

      this.updateFaq(payload)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.addModal = false;
          this.showLoading = false;
          this.faqList();
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
        .msgBoxOk(message, {
          title: title,
          size: "sm",
          buttonSize: "sm",
          okVariant: variant,
          centered: true
        })
        .then(value => {
        })
        .catch(err => {
        });
    }
  }
};
</script>

<style>
.search-wrapper {
  width: 100%;
  max-width: 222px;
}

.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>